/**
 * Step 2 - Requirements Component
 */

import React from 'react';
import EnhancedSkillsSelector from '../../../components/job-posting/EnhancedSkillsSelector';

export const Step2Requirements = React.memo(({ jobData, errors, onUpdate }) => {
  const handleInputChange = (field, value) => {
    onUpdate({ [field]: value });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Requirements & Responsibilities
        </h3>

        <div className="space-y-6">
          <div>
            <EnhancedSkillsSelector
              selectedSkills={jobData.skills_required}
              onSkillsChange={(skills) => handleInputChange('skills_required', skills)}
              error={errors.skills_required}
              label="Required Skills"
              placeholder="Search for skills or add custom ones..."
              required={true}
              maxSkills={15}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Key Responsibilities <span className="text-red-500">*</span>
            </label>
            <textarea
              value={jobData.responsibilities}
              onChange={(e) => handleInputChange('responsibilities', e.target.value)}
              placeholder="• Manage email correspondence and calendar scheduling&#10;• Handle customer inquiries and support tickets&#10;• Create and maintain documentation..."
              rows={6}
              className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary ${
                errors.responsibilities ? 'border-red-500' : 'border-border'
              }`}
            />
            {errors.responsibilities && (
              <p className="mt-1 text-sm text-red-600">{errors.responsibilities}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Requirements & Qualifications <span className="text-red-500">*</span>
            </label>
            <textarea
              value={jobData.requirements}
              onChange={(e) => handleInputChange('requirements', e.target.value)}
              placeholder="• 2+ years of virtual assistant experience&#10;• Excellent written and verbal communication skills&#10;• Proficiency in Microsoft Office and Google Workspace..."
              rows={6}
              className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary ${
                errors.requirements ? 'border-red-500' : 'border-border'
              }`}
            />
            {errors.requirements && (
              <p className="mt-1 text-sm text-red-600">{errors.requirements}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

Step2Requirements.displayName = 'Step2Requirements';
